var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stars",style:({ 'vertical-align': _vm.align ? 'middle' : 'baseline' }),attrs:{"title":_vm.title}},[_c('div',{staticClass:"stars-content stars-content-bg",style:(_vm.starsContentStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }